import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/LinkIcon";

import "./styles.less";
const isWindow = () => typeof window !== "undefined";
const isDocument = () => typeof document !== "undefined";
export const SolutionSceneScreen = () => {
  const { t } = useTranslation();
  const [topValue, setTopValue] = useState("0px");
  const [bottomValue, setBottomValue] = useState();
  const [scrollTop, setScrollTop] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);
  const list = [
    {
      mode: "dark",
      date: t("aboutus.process.item1.date"),
      content: t("aboutus.process.item1.text"),
      contentEn: t("aboutus.process.item1.textEn"),
    },
    {
      mode: "light",
      date: t("aboutus.process.item2.date"),
      content: t("aboutus.process.item2.text"),
      contentEn: t("aboutus.process.item2.textEn"),
    },
    {
      mode: "dark",
      date: t("aboutus.process.item3.date"),
      content: t("aboutus.process.item3.text"),
      contentEn: t("aboutus.process.item3.textEn"),
    },
    {
      mode: "light",
      date: t("aboutus.process.item4.date"),
      content: t("aboutus.process.item4.text"),
      contentEn: t("aboutus.process.item4.textEn"),
    },
    {
      mode: "dark",
      date: t("aboutus.process.item5.date"),
      content: t("aboutus.process.item5.text"),
      contentEn: t("aboutus.process.item5.textEn"),
    },
    {
      mode: "light",
      date: t("aboutus.process.item6.date"),
      content: t("aboutus.process.item6.text"),
      contentEn: t("aboutus.process.item6.textEn"),
    },
    {
      mode: "dark",
      date: t("aboutus.process.item7.date"),
      content: t("aboutus.process.item7.text"),
      contentEn: t("aboutus.process.item7.textEn"),
    },
  ];
  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const chrildElement =
        isDocument() && document.querySelector(".bannerBox-right-chrild");
      const documentScrollTop =
        (isDocument() && document.body.scrollTop) ||
        document.documentElement.scrollTop;
      const selfHeight =
        isWindow() &&
        Number(window.getComputedStyle(chrildElement).height.split("px")[0]);
      if (topValue < documentScrollTop) {
        const index = Math.round((documentScrollTop - topValue) / selfHeight);
        if (index < list.length) {
          setBannerIndex(index);
        }
      }
      setScrollTop(documentScrollTop);
    }
  });
  useEffect(() => {
    scrollHandler();
  }, [scrollHandler]);
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
  useEffect(() => {
    if (isWindow()) {
      const bannerBox = document.getElementById("bannerBox");
      if (bannerBox) {
        setTopValue(bannerBox.offsetTop);
        setBottomValue(
          isWindow() &&
            Number(window.getComputedStyle(bannerBox).height.split("p")[0]) +
              topValue,
          +"px"
        );
      }
    }
  }, [scrollHandler, topValue]);
  const clientHeight =
    (isDocument() && document.documentElement.clientHeight) || "";
  const cls = classNames({
    "bannerBox-top": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  const cls2 = classNames({
    "bannerBox-bottom": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });

  const renderScrollScreen = () => {
    return (
      <div className="aboutus-process-warp">
        <div className="banner-connection" id="bannerBox">
          <div className={cls}></div>
          <div className={cls2}></div>
          <div className="bannerBox-list">
            {list.map((item, index) => {
              return (
                <div key={"bannerBox-right" + index}>
                  <div className="bannerBox-right">
                    <div className="bannerBox-right-chrild">
                      <div
                        // className={
                        //   item.mode === "light"
                        //     ? "process-item light"
                        //     : "process-item"
                        // }
                        className="process-item"
                        onMouseEnter={() => {}}
                        onMouseLeave={() => {}}
                      >
                        <div className="process-item-date">{item.date}</div>
                        <div className="process-item-bar"></div>
                        <div className="process-item-content">
                          <div className="process-item-content-zh">
                            {item.content}
                          </div>
                          <div className="process-item-content-en">
                            {item.contentEn}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  return <>{renderScrollScreen()}</>;
};
